export const ON_CHAIN_BBG_LOGO =
  'https://hmseykssvtyrihuxymeo.supabase.co/storage/v1/object/public/bbt/public/image/logo/bbg_token.png';

export const ON_CHAIN_GGMOMOMO_LOGO = '/image/logo/gg01.png';

export const ON_CHAIN_WLD_LOGO = '/image/logo/worldcoin_white.png';

export const IN_GAME_BBG_LOGO = '/image/logo/bbg_icon_01.png';
